<template>
  <div class="consumable-query">
    <el-row class="condition">
      <el-form size="small" :inline="true">
        <el-form-item label="车牌号：">
          <el-input v-model="queryParam.vehicleNo" clearable placeholder="车牌号" style="width: 140px" />
        </el-form-item>
        <el-form-item label="司机编号：">
          <el-input v-model="queryParam.bindDriverNo" clearable placeholder="司机编号" style="width: 120px" />
        </el-form-item>
        <el-form-item label="类型：">
          <el-select v-model="queryParam.type" placeholder="请选择" @change="handleTypeChange" clearable
            style="width: 120px">
            <el-option v-for="item in consumableTypeOpts" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="起始日期：">
          <el-date-picker v-model="queryParam.installDateStart" type="date" @change="handleDateChange"
            placeholder="安装日期起" value-format="yyyy-MM-dd" clearable style="width: 140px" />
        </el-form-item>
        <el-form-item label="结束日期：">
          <el-date-picker v-model="queryParam.installDateEnd" type="date" @change="handleDateChange" placeholder="安装日期止"
            value-format="yyyy-MM-dd" clearable style="width: 140px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryList()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <div class="table">
      <el-table :data="list" stripe max-height="520">
        <el-table-column label="序号" type="index" width="50" />
        <el-table-column prop="vehicleNo" label="车牌号" width="100" />
        <el-table-column prop="bindDriverName" label="司机姓名" width="100" show-overflow-tooltip />
        <el-table-column prop="installReason" label="更换/安装事由" min-width="120" show-overflow-tooltip />
        <el-table-column prop="type" label="类型" width="90">
          <template slot-scope="scope">
            {{ scope.row.type | enumTransfer(consumableTypeOpts, 'value', 'label') }}
            <span v-if="scope.row.position"> {{ scope.row.position }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="uniCode" label="编号" width="95" />
        <el-table-column prop="installDate" label="安装日期" width="110" />
        <el-table-column prop="runMileage" label="已行驶里程(km)" width="120" />
        <el-table-column prop="usageDays" label="已使用天数" width="95" />
        <el-table-column prop="installInitialMileage" label="安装时里程(km)" width="120" />
        <el-table-column prop="cost" label="费用(元)" width="90" align="right">
          <template slot-scope="scope">
            {{ scope.row.cost != null ? scope.row.cost : '—' }}
          </template>
        </el-table-column>
        <el-table-column label="安装照片" width="90" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.installPhotos">
              <el-image v-if="firstPhotoUrl(scope.row.installPhotos)"
                style="width: 40px; height: 40px; vertical-align: middle" :src="firstPhotoUrl(scope.row.installPhotos)"
                :preview-src-list="photoList(scope.row.installPhotos)" fit="cover" />
              <span v-else>有</span>
            </template>
            <span v-else class="text-placeholder">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="brand" label="品牌" width="90" />
        <el-table-column prop="size" label="尺寸" width="80" />
        <el-table-column prop="productionDate" label="生产日期" width="110" />


        <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip />
        <el-table-column prop="unusable" label="状态" width="70">
          <template slot-scope="scope">
            <el-tag :type="scope.row.unusable ? 'info' : 'success'" size="small">
              {{ scope.row.unusable ? '已更换' : '在用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.type === 'TIRE'" type="text" size="small" @click="openTireOpDialog(scope.row)">
              操作记录
            </el-button>
            <span v-else class="text-placeholder">—</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination background :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="total" @current-change="handlePageChange" />
    </div>

    <!-- 轮胎操作记录弹窗 -->
    <el-dialog title="轮胎操作记录" :visible.sync="tireOpDialogVisible" width="900px" append-to-body>
      <div v-if="currentTireRow" class="tire-op-summary">
        <span>车牌号：{{ currentTireRow.vehicleNo }}</span>
        <span style="margin-left: 16px">位置：{{ currentTireRow.position }}</span>
        <span style="margin-left: 16px">轮胎规格：{{ currentTireRow.size || '—' }}</span>
      </div>
      <el-table :data="tireOpList" stripe max-height="400" size="small" style="margin-top: 12px">
        <el-table-column label="序号" type="index" width="50" />
        <el-table-column prop="opDesc" label="操作类型" width="100">

        </el-table-column>
        <el-table-column prop="opTime" label="操作时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.opTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column prop="curMileage" label="当前里程(km)" width="100" align="right">
          <template slot-scope="scope">
            {{ scope.row.curMileage != null ? scope.row.curMileage : '—' }}
          </template>
        </el-table-column>
        <el-table-column prop="addMileage" label="新增里程(km)" width="100" align="right">
          <template slot-scope="scope">
            {{ scope.row.addMileage != null ? scope.row.addMileage : '—' }}
          </template>
        </el-table-column>
        <el-table-column label="轮位" prop="position" width="120">
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
        <el-table-column prop="operatorName" label="操作人" width="90" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.operatorName || scope.row.supplierName }}
          </template>
        </el-table-column>
        <el-table-column prop="cost" label="费用(元)" width="90" align="right">
          <template slot-scope="scope">
            {{ scope.row.cost != null ? scope.row.cost : '—' }}
          </template>
        </el-table-column>
        <el-table-column label="照片" width="70" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.photos">
              <el-image v-if="firstPhotoUrl(scope.row.photos)" style="width: 36px; height: 36px; vertical-align: middle"
                :src="firstPhotoUrl(scope.row.photos)" :preview-src-list="photoList(scope.row.photos)" fit="cover" />
              <span v-else>有</span>
            </template>
            <span v-else class="text-placeholder">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="80" show-overflow-tooltip />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tireOpDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ParamUtil } from "@/util";
import { listConsumable, listTireOp } from "@/api";

const CONSUMABLE_TYPE_OPTS = [
  { value: "TIRE", label: "轮胎" },
  { value: "WIPER", label: "雨刷" },
  { value: "SMALL_BATTERY", label: "小电瓶" },
  { value: "BRAKE_PAD", label: "刹车片" },
  { value: "KEY_BATTERY", label: "钥匙电池" },
  { value: "FOOTREST", label: "脚垫" }
];


export default {
  name: "ConsumableQuery",
  data() {
    return {
      queryParam: {
        vehicleNo: "",
        bindDriverNo: "",
        type: "",
        installDateStart: "",
        installDateEnd: ""
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      consumableTypeOpts: CONSUMABLE_TYPE_OPTS,
      tireOpDialogVisible: false,
      tireOpList: [],
      currentTireRow: null
    };
  },
  created() {
    this.queryList();
  },
  methods: {
    firstPhotoUrl(photos) {
      if (!Array.isArray(photos) || photos.length === 0) return "";
      const urls = photos.map((s) => (s || "").toString().trim()).filter(Boolean);
      return urls[0] || "";
    },
    photoList(photos) {
      if (!Array.isArray(photos) || photos.length === 0) return [];
      return photos.map((s) => (s || "").toString().trim()).filter(Boolean);
    },
    queryList(page = 1) {
      const param = {
        page: { current: page, size: this.pageSize },
        param: ParamUtil.filterEmptyData(this.queryParam)
      };
      listConsumable(param).then((res) => {
        const data = res.data || {};
        this.list = data.records || [];
        this.total = data.total || 0;
        this.currentPage = data.current || 1;
      });
    },
    handlePageChange(page) {
      this.queryList(page);
    },

    openTireOpDialog(row) {
      this.currentTireRow = row;
      this.tireOpDialogVisible = true;
      this.tireOpList = [];
      listTireOp(row.id).then((res) => {
        this.tireOpList = res.data || [];
      });
    }
  }
};
</script>

<style scoped>
.consumable-query .condition {
  margin-bottom: 12px;
}

.consumable-query .page {
  margin-top: 12px;
  text-align: right;
}

.text-placeholder {
  color: #c0c4cc;
}

.tire-op-summary {
  font-size: 13px;
  color: #606266;
}
</style>
